import { useMemo } from "react";
import { pickBy } from "@common/helpers/objects";

export function useDataAttributes<P extends Record<string, any>>(props: P) {
    return useMemo(
        () => pickBy(props, (value, key) => key.startsWith("data-")),
        [props],
    ) as Record<string, string>;
}
